import ClassHelper from '../ClassHelper';
import Excursion from '../excursion/Excursion';
import PlaceDetails from '../place/PlaceDetails';
import Transport from '../transport/Transport';
import Route from './Route';

class RouteDetails extends ClassHelper {
  constructor({ _id = null, route, number, date, duration = 0, status, excursions = [], transports = [], places = []} = {}) {
    super(...arguments);
    this.route = this.obj(route || _id, Route);
    this.number = number;
    this.date = date;
    this.duration = duration;
    this.status = status; // ScheduleStatus
    this.excursions = this.array(excursions, Excursion);
    this.transports = this.array(transports, Transport);
    this.places = this.array(places, PlaceDetails);
  }
}

export default RouteDetails;